<template>
  <v-card>
    <v-form>
      <v-card-title>
        {{ $t('dictionaries.addNew.risk') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.name"
              :label="$t('common.name')"
              outlined
              dense
              counter="32"
              @change="$v.form.name.$touch()"
              :error-messages="errorMessages('name')"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.description"
              :label="$t('common.description')"
              outlined
              counter="64"
              dense
              @change="$v.form.description.$touch()"
              :error-messages="errorMessages('description')"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row class="mb-2 mx-2">
          <v-spacer />
          <v-btn
            rounded
            dense
            outlined
            small
            color="primary"
            @click="cancel"
            class="mr-2"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <SubmitButton small @click="submit" />
        </v-row>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { errorMessageGenerator, riskModel } from '@/validators'
import { saveDictionaryItem, getRisks } from '../services'

export default {
  name: 'RiskForm',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: { ...this.value }
    }
  },
  methods: {
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    },
    async submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        const risk = await saveDictionaryItem('risks', this.form)
        await getRisks()
        this.form = {}
        this.$emit('save', risk)
      }
    },
    cancel () {
      this.form = {}
      this.$v.$reset()
      this.$emit('cancel')
    }
  },
  watch: {
    value (v) {
      this.form = { ...v }
    }
  },
  validations: riskModel
}
</script>
